<template>
    <div class="p-3 t&g">
        <div class="bg-white border-radius-5 mb-3">
            <ul class="nav nav-tabs border-0 mobBG-white   customNavs pl-2 pr-3" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link" id="home-tab" href="javascript:void(0)" @click.prevent="changeTab('goals')" :class="[{'active':(tab == 'goals')}]">Goals</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="home-tab" href="javascript:void(0)" @click.prevent="changeTab('task')" :class="[{'active':(tab == 'task')}]">Action</a>
                </li>
            </ul>
        </div>
        <div class="taskandgoal">
            <!-- <div class="taskTitle d-flex justify-content-between align-items-center border-bottom mb-3 pb-3" v-if="tab == 'action'">
                <h3 class="mb-0">You’re on the right track.</h3>
                <div class="position-relative">
                    <button class="filter" @click="Drop = !Drop">
                        <img src="../../../../static/website/images/filter.svg">
                        <span>Filter</span>
                    </button>
                    <ul v-if="Drop" class="dropdownGoal">
                        <li>Previous Value</li>

                    </ul>
                </div>
            </div> -->
            <div class="showTask" v-if="tab == 'task'">
                <div class="table-reponsive">
                    <table class="table separateTable tasktable">
                        <thead>
                            <tr>
                              <th>Subject</th>
                              <th>Value</th>
                              <th>Created</th>
                            </tr>
                        </thead>
                        <tbody v-if="pageLoader">
                            <table-loader :colspan="3"></table-loader>
                        </tbody>
                        <tbody v-else-if="!pageLoader && !taskActionList.totalRecords">
                            <no-record :type="'table'" :colspan="3"></no-record>
                        </tbody>
                        <tbody v-else-if="!pageLoader && taskActionList.totalRecords && taskActionList.totalRecords > 0">
                            <tr v-for="list in taskActionList.records" v-if="list.to_do_id && parsed(list.to_do_id) && (parsed(list.to_do_id)['practise_rule'] || parsed(list.to_do_id)['tre'] || parsed(list.to_do_id)['to_do_steps'] || parsed(list.to_do_id)['to_do_comments'])">
                                <!-- {{parsed(list.to_do_id)}} -->
                                <td colspan="3" class="p-0 m-0 border-0">
                                    <table class="table mb-0 ">
                                        <tr v-if="parsed(list.to_do_id)['practise_rule']">
                                            <td>Practice 15:15 rule (15min walk after every 15 minutes of major meal intake)</td>
                                            <td>
                                                <ul class="d-flex align-items-center m-0 foodIntake">
                                                    <li class="bgcolor1">Breakfast</li> 
                                                    <li class="bgcolor2">Lunch</li> 
                                                    <li class="bgcolor3">Dinner</li>
                                                </ul>
                                            </td>
                                            <td>{{list.created | moment('DD MMM YYYY')}}</td>
                                        </tr>
                                        <tr v-if="parsed(list.to_do_id)['tre']">
                                            <td>
                                                TRE (Time Restricted Eating)
                                                <p v-if="$env_var.followUpTreJson[parsed(list.to_do_id)['tre'].window]">Eg. {{$env_var.followUpTreJson[parsed(list.to_do_id)['tre'].window]}} - {{$env_var.followUpTreJson[parsed(list.to_do_id)['tre'].window].split(':')[0]}} hrs is fasting window &amp; {{$env_var.followUpTreJson[parsed(list.to_do_id)['tre'].window].split(':')[1]}} hrs is eating window<br> </p>
                                            </td>
                                            <td>
                                                <!-- <span class="pl-0"> {{$env_var.followUpTreJson[parsed(list.to_do_id)['tre'].window] || '-'}}</span> -->
                                                <span class="pl-0">Start Time : {{parsed(list.to_do_id)['tre'].start_time}}</span>
                                                <span>End Time :{{parsed(list.to_do_id)['tre'].end_time}}</span>
                                            </td>
                                            <td>{{list.created | moment('DD MMM YYYY')}}</td>
                                        </tr>
                                        <tr v-if="parsed(list.to_do_id)['to_do_steps']">
                                            <td>Step Count</td>
                                            <td>{{parsed(list.to_do_id)['to_do_steps']}}</td>
                                            <td>{{list.created | moment('DD MMM YYYY')}}</td>
                                        </tr>
                                        <tr v-if="parsed(list.to_do_id)['to_do_comments']">
                                            <td>Other</td>
                                            <td>{{parsed(list.to_do_id)['to_do_comments']}}</td>
                                            <td>{{list.created | moment('DD MMM YYYY')}}</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <app-pagination :totalRecords="taskActionList.totalRecords" :limit="pageLimit" :pageNo="page" v-if="taskActionList.totalRecords && taskActionList.totalRecords > pageLimit"/>
            </div>
            <div class="showTask accordion-border" v-if="tab == 'goals'">
                <!-- <ul id="myTab" role="tablist" class="nav nav-tabs border-0 innerTableTab fixTab">
                    <li class="nav-item">
                        <a href="javascript:void(0)" class="nav-link" @click.prevent="taskTab = 'glucose'" :class="(taskTab == 'glucose')?'active':''">Blood Glucose</a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:void(0)" class="nav-link" @click.prevent="taskTab = 'pressure'" :class="(taskTab == 'pressure')?'active':''">Blood Pressure</a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:void(0)" class="nav-link" @click.prevent="taskTab = 'weight';" :class="(taskTab == 'weight')?'active':''">Weight</a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:void(0)" class="nav-link" @click.prevent="taskTab = 'waist_circumference'" :class="(taskTab == 'waist_circumference')?'active':''">Waist Circumference</a>
                    </li>
                </ul> -->
                <!-- Blood Glucose -->
                <div class="taskTabs" v-if="formatGoals('blood_glucose').length > 0">
                    <div class="TaskStep">
                        <div class="taskHeader d-flex align-items-center justify-content-between" :class="[{'closed':taskTab != 'glucose'}]"  @click="changeTabInner('glucose')">
                            <h4>Blood Glucose </h4>
                            <span class="arrow"><feather :type="taskTab == 'glucose'?'chevron-down':'chevron-up'"/></span>
                        </div>
                        <div class="table-responsive" v-show="taskTab == 'glucose'">
                            <table class="table Medicine-list mb-0 border-0 inerMedTable layout-inherit" border="0" cellspacing="0" cellpadding="0" v-if="taskTab == 'glucose'">
                                <thead>
                                    <tr>
                                        <th>Normal Range</th>
                                        <th>Fasting Blood Glucose</th>
                                        <th>Post meal Blood Glucose</th>
                                        <th>Priority</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                    </tr>
                                </thead>
                                <tbody v-if="pageLoader">
                                    <table-loader :colspan="6"></table-loader>
                                </tbody>
                                <tbody v-else-if="!pageLoader && formatGoals('blood_glucose').length == 0">
                                    <no-record :type="'table'" :colspan="6"></no-record>
                                </tbody>
                                <tbody v-else-if="formatGoals('blood_glucose').length > 0">
                                    <tr v-for="item in formatGoals('blood_glucose')">
                                        <td><span>{{(item.normal_range)  || '-'}}</span></td>
                                        <td><span>{{(item.systolic_bp) || '-'}}</span></td>
                                        <td><span>{{(item.diastolic_bp) || '-'}}</span></td>
                                        <td><span class="p-2" :class="(item.priority == 'Medium')?'bgcolor2':(item.priority == 'High')?'bgcolor3':(item.priority == 'Normal')?'bgcolor4':''">{{item.priority || '-'}}</span></td>
                                        <td><span v-if="item.start_time && item.start_time != 'Invalid date'">{{item.start_time | moment('DD MMM YYYY') || '-'}}</span><span v-else>-</span></td>
                                        <td><span v-if="item.end_time && item.end_time != 'Invalid date'">{{item.end_time | moment('DD MMM YYYY') || '-'}}</span><span v-else>-</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- Blood Pressure -->
                <div class="taskTabs" v-if="formatGoals('blood_pressure').length > 0">
                    <div class="TaskStep">
                        <div class="taskHeader d-flex align-items-center justify-content-between" :class="[{'closed':taskTab != 'pressure'}]"  @click="changeTabInner('pressure')">
                            <h4>Blood Pressure </h4>
                            <span class="arrow"><feather :type="taskTab == 'pressure'?'chevron-down':'chevron-up'"/></span>
                        </div>
                        <div class="table-responsive" v-show="taskTab == 'pressure'">
                            <table class="table Medicine-list mb-0 border-0 inerMedTable layout-inherit" border="0" cellspacing="0" cellpadding="0" v-if="taskTab == 'pressure'">
                                <thead>
                                    <tr>
                                        <th>Normal Range</th>
                                        <th>Systolic B.P.</th>
                                        <th>Diastolic B.P.</th>
                                        <th>Priority</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                    </tr>
                                </thead>
                                <tbody v-if="pageLoader">
                                    <table-loader :colspan="6"></table-loader>
                                </tbody>
                                <tbody v-else-if="!pageLoader && formatGoals('blood_pressure').length == 0">
                                    <no-record :type="'table'" :colspan="6"></no-record>
                                </tbody>
                                <tbody v-else-if="formatGoals('blood_pressure').length > 0">
                                    <tr v-for="item in formatGoals('blood_pressure')">
                                        <td><span>{{(item.normal_range)  || '-'}}</span></td>
                                        <td><span>{{(item.systolic_bp) || '-'}}</span></td>
                                        <td><span>{{(item.diastolic_bp) || '-'}}</span></td>
                                        <td><span class="p-2" :class="(item.priority == 'Medium')?'bgcolor2':(item.priority == 'High')?'bgcolor3':(item.priority == 'Normal')?'bgcolor4':''">{{item.priority || '-'}}</span></td>
                                        <td><span v-if="item.start_time && item.start_time != 'Invalid date'">{{item.start_time | moment('DD MMM YYYY') || '-'}}</span><span v-else>-</span></td>
                                        <td><span v-if="item.end_time && item.end_time != 'Invalid date'">{{item.end_time | moment('DD MMM YYYY') || '-'}}</span><span v-else>-</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- Weight -->
                <div class="taskTabs" v-if="formatGoals('weight').length > 0">
                    <div class="TaskStep">
                        <div class="taskHeader d-flex align-items-center justify-content-between" :class="[{'closed':taskTab != 'weight'}]"  @click="changeTabInner('weight')">
                            <h4>Weight </h4>
                            <span class="arrow"><feather :type="taskTab == 'weight'?'chevron-down':'chevron-up'"/></span>
                        </div>
                        <div class="table-responsive" v-show="taskTab == 'weight'">
                            <table class="table Medicine-list mb-0 border-0 inerMedTable layout-inherit" border="0" cellspacing="0" cellpadding="0" v-if="taskTab == 'weight'">
                                <thead>
                                    <tr>
                                        <th>Reduced By</th>
                                        <th>Unit</th>
                                        <th>Goal Weight</th>
                                        <th>Priority</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                    </tr>
                                </thead>
                                <tbody v-if="pageLoader">
                                    <table-loader :colspan="6"></table-loader>
                                </tbody>
                                <tbody v-else-if="!pageLoader && formatGoals('weight').length == 0">
                                    <no-record :type="'table'" :colspan="6"></no-record>
                                </tbody>
                                <tbody v-else-if="formatGoals('weight').length > 0">
                                    <tr v-for="item in formatGoals('weight')">
                                        <td><span>{{(item.to_reduce_by)  || '-'}}</span></td>
                                        <td><span>{{(item.unit) || '-'}}</span></td>
                                        <td><span>{{(item.goal_weight) || '-'}}</span></td>
                                        <td><span class="p-2" :class="(item.priority && item.priority == 'Medium')?'bgcolor2':(item.priority == 'High')?'bgcolor3':(item.priority == 'Normal')?'bgcolor4':''">{{item.priority || '-'}}</span></td>
                                        <td><span v-if="item.start_time && item.start_time != 'Invalid date'">{{item.start_time | moment('DD MMM YYYY') || '-'}}</span><span v-else>-</span></td>
                                        <td><span v-if="item.end_time && item.end_time != 'Invalid date'">{{item.end_time | moment('DD MMM YYYY') || '-'}}</span><span v-else>-</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- Waist Circumference -->
                <div class="taskTabs" v-if="formatGoals('waist_circumference').length > 0">
                    <div class="TaskStep">
                        <div class="taskHeader d-flex align-items-center justify-content-between" :class="[{'closed':taskTab != 'waist_circumference'}]"  @click="changeTabInner('waist_circumference')">
                            <h4>Waist Circumference </h4>
                            <span class="arrow"><feather :type="taskTab == 'waist_circumference'?'chevron-down':'chevron-up'"/></span>
                        </div>
                        <div class="table-responsive" v-show="taskTab == 'waist_circumference'">
                            <table class="table Medicine-list mb-0 border-0 inerMedTable layout-inherit" border="0" cellspacing="0" cellpadding="0" v-if="taskTab == 'waist_circumference'">
                                <thead>
                                    <tr>
                                        <th>Reduced By</th>
                                        <th>Unit</th>
                                        <th>Goal</th>
                                        <th>Priority</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                    </tr>
                                </thead>
                                <tbody v-if="pageLoader">
                                    <table-loader :colspan="6"></table-loader>
                                </tbody>
                                <tbody v-else-if="!pageLoader && formatGoals('waist_circumference').length == 0">
                                    <no-record :type="'table'" :colspan="6"></no-record>
                                </tbody>
                                <tbody v-else-if="formatGoals('waist_circumference').length > 0">
                                    <tr v-for="item in formatGoals('waist_circumference')">
                                        <td><span>{{(item.to_reduce_by)  || '-'}}</span></td>
                                        <td><span>{{(item.unit) || '-'}}</span></td>
                                        <td><span>{{(item.goal_weight) || '-'}}</span></td>
                                        <td><span class="p-2" :class="(item.priority == 'Medium')?'bgcolor2':(item.priority == 'High')?'bgcolor3':(item.priority == 'Normal')?'bgcolor4':''">{{item.priority || '-'}}</span></td>
                                        <td><span v-if="item.start_time && item.start_time != 'Invalid date'">{{item.start_time | moment('DD MMM YYYY') || '-'}}</span><span v-else>-</span></td>
                                        <td><span v-if="item.end_time && item.end_time != 'Invalid date'">{{item.end_time | moment('DD MMM YYYY') || '-'}}</span><span v-else>-</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="taskTabs" v-if="formatGoals('HbA1c').length > 0">
                    <div class="TaskStep">
                        <div class="taskHeader d-flex align-items-center justify-content-between" :class="[{'closed':taskTab != 'HbA1c'}]"  @click="changeTabInner('HbA1c')">
                            <h4>HbA1c</h4>
                            <span class="arrow"><feather :type="taskTab == 'HbA1c'?'chevron-down':'chevron-up'"/></span>
                        </div>
                        <div class="table-responsive" v-show="taskTab == 'HbA1c'">
                            <table class="table Medicine-list mb-0 border-0 inerMedTable layout-inherit" border="0" cellspacing="0" cellpadding="0" v-if="taskTab == 'HbA1c'">
                                <thead>
                                    <tr>
                                        <th>Value</th>
                                        <th>Unit</th>
                                        <th>Priority</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                    </tr>
                                </thead>
                                <tbody v-if="pageLoader">
                                    <table-loader :colspan="5"></table-loader>
                                </tbody>
                                <tbody v-else-if="!pageLoader && formatGoals('HbA1c').length == 0">
                                    <no-record :type="'table'" :colspan="5"></no-record>
                                </tbody>
                                <tbody v-else-if="formatGoals('HbA1c').length > 0">
                                    <tr v-for="item in formatGoals('HbA1c')">
                                        <td><span>{{(item.to_reduce_by)  || '-'}}</span></td>
                                        <td><span>{{(item.unit) || '-'}}</span></td>
                                        <td><span class="p-2" :class="(item.priority == 'Medium')?'bgcolor2':(item.priority == 'High')?'bgcolor3':(item.priority == 'Normal')?'bgcolor4':''">{{item.priority || '-'}}</span></td>
                                        <td><span v-if="item.start_time && item.start_time != 'Invalid date'">{{item.start_time | moment('DD MMM YYYY') || '-'}}</span><span v-else>-</span></td>
                                        <td><span v-if="item.end_time && item.end_time != 'Invalid date'">{{item.end_time | moment('DD MMM YYYY') || '-'}}</span><span v-else>-</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="taskTabs" v-if="formatGoals('TSH').length > 0">
                    <div class="TaskStep">
                        <div class="taskHeader d-flex align-items-center justify-content-between" :class="[{'closed':taskTab != 'TSH'}]"  @click="changeTabInner('TSH')">
                            <h4>TSH</h4>
                            <span class="arrow"><feather :type="taskTab == 'TSH'?'chevron-down':'chevron-up'"/></span>
                        </div>
                        <div class="table-responsive" v-show="taskTab == 'TSH'">
                            <table class="table Medicine-list mb-0 border-0 inerMedTable layout-inherit" border="0" cellspacing="0" cellpadding="0" v-if="taskTab == 'TSH'">
                                <thead>
                                    <tr>
                                        <th>Value</th>
                                        <th>Priority</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                    </tr>
                                </thead>
                                <tbody v-if="pageLoader">
                                    <table-loader :colspan="4"></table-loader>
                                </tbody>
                                <tbody v-else-if="!pageLoader && formatGoals('TSH').length == 0">
                                    <no-record :type="'table'" :colspan="4"></no-record>
                                </tbody>
                                <tbody v-else-if="formatGoals('TSH').length > 0">
                                    <tr v-for="item in formatGoals('TSH')">
                                        <td><span>{{(item.to_reduce_by)  || '-'}}</span></td>
                                        <td><span class="p-2" :class="(item.priority == 'Medium')?'bgcolor2':(item.priority == 'High')?'bgcolor3':(item.priority == 'Normal')?'bgcolor4':''">{{item.priority || '-'}}</span></td>
                                        <td><span v-if="item.start_time && item.start_time != 'Invalid date'">{{item.start_time | moment('DD MMM YYYY') || '-'}}</span><span v-else>-</span></td>
                                        <td><span v-if="item.end_time && item.end_time != 'Invalid date'">{{item.end_time | moment('DD MMM YYYY') || '-'}}</span><span v-else>-</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="taskTabs" v-if="formatGoals('blood_glucose').length == 0 && formatGoals('blood_pressure').length == 0 && formatGoals('weight').length == 0 && formatGoals('waist_circumference').length == 0 && formatGoals('HbA1c').length == 0 && formatGoals('TSH').length == 0">
                    <div class="TaskStep">
                        <div class="table-responsive">
                            <table class="table Medicine-list mb-0 border-0 inerMedTable layout-inherit" border="0" cellspacing="0" cellpadding="0">
                                <tbody v-if="pageLoader">
                                    <table-loader :colspan="6"></table-loader>
                                </tbody>
                                <tbody v-else>
                                    <no-record :type="'table'" :colspan="6"></no-record>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- <app-pagination :totalRecords="taskActionList.totalRecords" :limit="pageLimit" :pageNo="page" v-if="taskActionList.totalRecords && taskActionList.totalRecords > pageLimit"/> -->
                <!-- <div class="medicine-current d-flex notes border-radius-5 p-3 bg-white ">
                    <div class="row no-gutter w-100">
                        <div class="col-lg-4">
                            <h3>Suggestion: </h3>
                        </div>
                        <div class="col-lg-4">
                            <p><i class="icon icon-check"></i>No gluten containing food.</p>
                            <p><i class="icon icon-check"></i>Repeat Gut q after 2 weeks of no gluten.</p>
                            <p><i class="icon icon-check"></i>Add ghee, nuts.</p>
                        </div>
                      <div class="col-lg-4">
                            <p><i class="icon icon-check"></i>No gluten containing food.</p>
                            <p><i class="icon icon-check"></i>Repeat Gut q after 2 weeks of no gluten.</p>
                            <p><i class="icon icon-check"></i>Add ghee, nuts.</p>
                      </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
    export default {
        name: "goals-and-actions",
        data() {
            return {
                pageLoader: false,
                Drop: false,
                pageNo:'',
                tab:'goals',
                taskTab : 'glucose',
                page: 1,
                pageLimit:10,
            }
        },
        methods:{
            changeTabInner(val){
                if(this.taskTab == val){
                    this.taskTab = ''
                }else{
                    this.taskTab = val
                }
            },
            formatGoals(type){
                try{
                    let _that = this
                    let returnData = []
                    if(Object.keys( _that.taskActionList).length > 0){
                        _that.taskActionList.records.forEach(val=>{
                            // console.log('===>',_that.parsed(val.goal_id))
                            let data = _that.parsed(val.goal_id)[type]
                            if(data && Object.keys(data).length > 0){
                                returnData.push(data)
                            }
                        })
                    }
                    return returnData
                }catch(e){ console.log(e);return []; }
            },
            parsed(list){
                return JSON.parse(list)[0] || ''
            },
            changeTab(val){
                if(this.tab != val){
                    this.tab = val
                    this.listing()
                }
            },
            listing(){
                let input_json = {
                    'globalParams' : {
                        "page": this.page, 
                        "limit": this.pageLimit,
                        "type":this.tab
                    },
                    'localParams' :{'parameter' : this}
                }
                if(input_json.globalParams.type == 'goals'){
                    input_json.globalParams.limit = 1
                }
                this._runGetTaskActionList(input_json)
            }
        },
        created(){
            this.listing()
            this.pageName('Goals And Actions')
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/goals_and_actions/goals_and_actions.vue